import _ from 'lodash'
import API from './common/commonAPI'

const BlogService = {
  getPostsBlog: async () => {
    const response = await API.get(
      `https://grupomoure.com//wp-json/wp/v2/posts`,
    )
    const data = _.map(response.data, 'yoast_head_json')
    const newObject = _.map(data, (elem) =>
      _.pick(elem, [
        'title',
        'og_description',
        'article_published_time',
        'og_image[0].url',
        'og_url',
      ]),
    )
    return newObject
  },
}

export default BlogService
